import React, { useEffect, useState } from "react";

import * as decoValidation from "../validations/decoMethodValidations";
import { useMastersContext } from "../../../../../contexts/masters.context";
import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import SelectFormControl from "../../../shared/form-controls/SelectFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

function DecoMethodsForm({ formData, setFormData, formErrors, setFormErrors }) {
  const { colorPricingCategoryState } = useMastersContext();

  const handleInputChange = (event) => {
    const key = event.currentTarget.name;
    const value = event.currentTarget.value;
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnBlur = (event, validationCalback) => {
    const key = event.currentTarget.name;
    const value = event.currentTarget.value;
    const validator = decoValidation[key];
    if (validator) {
      setFormErrors({ ...formErrors, [key]: validationCalback(value) });
    }
  };

  useEffect(() => {
    colorPricingCategoryState.fetch();
  }, []);

  return (
    <div className="container" style={{ textAlign: "initial" }}>
      <div className="row justify-content-md-center">
        <div className="col-md">
          <form onSubmit={(e) => e.preventDefault()} noValidate>
            <TextInputFormControl
              label="Deco Name"
              id="name"
              name="name"
              value={formData.name}
              placeholder="Deco Method Name"
              onChange={handleInputChange}
              onBlur={(e) => handleOnBlur(e, decoValidation.name)}
              error={formErrors.name}
              required
            />
            <TextInputFormControl
              label="Hyphanate Name"
              id="hyphanateName"
              name="hyphanateName"
              value={formData.hyphanateName}
              placeholder="Hyphanate Name"
              onBlur={(e) => handleOnBlur(e, decoValidation.hyphanateName)}
              onChange={handleInputChange}
              error={formErrors.hyphanateName}
              required
            />
            <TextInputFormControl
              label="PPC Feed Name"
              id="ppcName"
              name="ppcName"
              value={formData.ppcName}
              placeholder="PPC Feed Name"
              onBlur={(e) => handleOnBlur(e, decoValidation.ppcName)}
              onChange={handleInputChange}
              error={formErrors.ppcName}
              required
            />
            <TextInputFormControl
              label="Product Examples"
              id="productExamples"
              name="productExamples"
              value={formData.productExamples}
              placeholder="Product Examples"
              onBlur={(e) => handleOnBlur(e, decoValidation.productExamples)}
              onChange={handleInputChange}
              error={formErrors.productExamples}
              required
            />
            <NumberInputFormControl
              label="Color Max"
              id="colorsMax"
              name="colorsMax"
              max={50}
              value={formData.colorsMax}
              placeholder="Color Max"
              onBlur={(e) => handleOnBlur(e, decoValidation.colorsMax)}
              onChange={handleInputChange}
              error={formErrors.colorsMax}
              required
            />
            {colorPricingCategoryState.data ? (
              <SelectFormControl
                label="Color Pricing Category"
                id="colorPricingCategoryID"
                name="colorPricingCategoryID"
                options={colorPricingCategoryState.data}
                optionLabelField="pricingType"
                optionValueField="cpC_ID"
                value={formData.colorPricingCategoryID}
                onBlur={(e) =>
                  handleOnBlur(e, decoValidation.colorPricingCategoryID)
                }
                onChange={handleInputChange}
                selectAll
                selectAllText=" "
                error={formErrors.colorPricingCategoryID}
                required
              />
            ) : (
              "Loading color pricing categories..."
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default DecoMethodsForm;
